module.exports = __webpack_public_path__ + "img/full2-min.45927e8a.png";